import axios from 'axios';
const version = process.env.REACT_APP_VERSION;

axios.defaults.headers.common['zumba'] = version;